// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Belt_List = require("bs-platform/lib/js/belt_List.js");
var Traversing$XodProject = require("./Traversing.bs.js");

function listUpstreamPinsToNiixU(pinPairs, currentPatch, project) {
  return Belt_List.toArray(Traversing$XodProject.listUpstreamPinsToNiix(Belt_List.fromArray(pinPairs), currentPatch, project));
}

exports.listUpstreamPinsToNiixU = listUpstreamPinsToNiixU;
/* Traversing-XodProject Not a pure module */
